import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('atomchat', (editor, opts = {}) => {
  let c = opts;
  const default_types = {
    atomchatButton: 'atomchat',
  };
  const default_labels = {
    atomchatButton: 'Atomchat',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelAtomchatCategory: 'Advanced',
    },
    ...opts,
  };
  for (let name in options) {
    if (!(name in c)) c[name] = options[name];
  }
  loadComponents(editor, opts);
});
